import forEach from 'lodash/forEach';
import {matches} from '../utils/index';


export default class Navigation {
    constructor({el}) {
        this.el = el;
        this.nav = document.getElementById('primary-menu');
        this.window = window;
        this.htmlNode = document.getElementsByTagName('html')[0];
        this.classNameTrigger = 'menu-opened';

        this.render();
    }

    getMinSpacing(wh) {
        if (wh < 500) {
            return 25;
        } else if (wh < 700) {
            return 50;
        } else if (wh < 900) {
            return 75;
        } else {
            return 200;
        }
    }

    setMenuItemSpacing() {
        const wh = this.window.outerHeight === 0 ? this.window.innerHeight : this.window.outerHeight;
        const y = this.getMinSpacing(wh);
        const available = (wh - 50) - (2 * y);
        const items = this.nav.getElementsByTagName('li');
        const itemCount = items.length;
        const fontSize = 16;
        const padding = Math.floor(((available / itemCount) - fontSize) / 2);

        forEach(items, el => {
            el.style.padding = `${padding}px 0`;
        });
    }

    render() {
        this.setMenuItemSpacing();
        const vh = this.window.outerHeight - 50;
        const ulh = this.nav.outerHeight;

        this.nav.style.top = ((vh - ulh) / 2) + 50;

        this.bind();
        return this;
    }

    bind() {
        // $(window).on('resize', $.proxy(this.render, this));

        document.body.addEventListener('keyup', evt => {
            if (evt.keyCode === 27 && this.htmlNode.classList.contains(this.classNameTrigger)) {
                this.htmlNode.classList.remove(this.classNameTrigger);
            }
        });

        this.el.addEventListener('click', evt => {
            const target = evt.target;

            if (matches(target, '.burger-container') || matches(target.parentNode, '.burger-container') || matches(target, '.bar')) {
                this.htmlNode.classList.toggle(this.classNameTrigger);

                evt.preventDefault();
            }

            if (matches(target, '.header')) {
                if (this.htmlNode.classList.contains(this.classNameTrigger)) {
                    this.htmlNode.classList.remove(this.classNameTrigger);
                }
            }
        });
    }
}
